import arrayParser from "../arrayParser"

const pigmentedSkinProcessor=(element, melanomaSevenPoint)=>
{
let assembledElement = ""

assembledElement += ` ${(element["duration"] !== "" ? " had" : "")} a pigmented skin lesion`

if (element["Size"] !== "")
    {
    assembledElement += `  which is ${element["Size"]}cm in diameter`
    }

if (element["Site(s)"] !== "")
    {
    assembledElement += ` on their ${element["Site(s)"]} `
    }

if (element["Description"] !== "")    
    {
    assembledElement += ` described as ${element["Description"]}`
    }

if (element["Present_for_several:"] !== "")
    assembledElement += ` for several ${(element["Present_for_several:"]).toLowerCase()}`

assembledElement += "."

if (element["Use_info_from_checklist:"] === "Yes")
    {
    const melanomaPoints=
    {
    ChangeSensation: "change in sensation",
    changeInSize: "change in size",
    inflammation: "inflammation",
    irregularColour:  "irregular colour",
    irregularShape: "irregular shape",
    largestDiameter: "a largest diameter of 7 mm or more",
    oozing: "oozing"
    }
    let pointList=[]

    for (const [key, value] of Object.entries(melanomaSevenPoint)) 
        {
        if (value)
            {
            pointList.push(melanomaPoints[key])
            }
        }
    let pointsText = arrayParser(pointList)

    assembledElement += `  The lesion has concering features from the melanoma seven point checklist including ${pointsText}`
    }

return (assembledElement)
}

export default pigmentedSkinProcessor